import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import {  
  FaLightbulb, 
  FaArrowLeft,
  FaCode,
  FaPalette,
  FaRocket,
  FaCogs,
  FaComments,
  FaVideo,
  FaBook,
  FaTools,
  FaBuilding,
  FaUniversity,
  FaCalendarAlt,
  FaHeart,
  FaGlobe,
  FaStar
} from 'react-icons/fa';
import './ServicePage.css';
import WhatsappFloat from '../components/WhatsappFloat';
import { Helmet } from 'react-helmet-async';

const Consultorias = () => {
  const navigate = useNavigate();

  // Scroll para o topo quando a página carrega
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <Helmet>
        <title>Consultorias | MicroCodie</title>
        <meta name="description" content="Consultorias, palestras e workshops em tecnologia, inovação e transformação digital. Evolua com conhecimento real." />
        <meta property="og:title" content="Consultorias | MicroCodie" />
        <meta property="og:description" content="Consultorias, palestras e workshops em tecnologia, inovação e transformação digital. Evolua com conhecimento real." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.microcodie.com.br/servicos/consultorias" />
        <meta property="og:image" content="/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Consultorias | MicroCodie" />
        <meta name="twitter:description" content="Consultorias, palestras e workshops em tecnologia, inovação e transformação digital. Evolua com conhecimento real." />
        <meta name="twitter:image" content="/logo192.png" />
        <link rel="canonical" href="https://www.microcodie.com.br/servicos/consultorias" />
      </Helmet>
      <div className="service-page">
        <div className="service-header">
          <div className="container">
            <motion.button 
              className="back-button"
              onClick={() => navigate('/')}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <FaArrowLeft />
              Voltar
            </motion.button>
            
            <motion.div 
              className="service-hero"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="service-icon-large">
                <FaLightbulb />
              </div>
              <h1>Compartilhamos conhecimento com impacto</h1>
              <p className="service-subtitle">
                Consultorias, palestras, cursos e workshops que ajudam pessoas e negócios a crescerem
              </p>
              <button 
                className="btn btn-primary hero-cta"
                onClick={() => navigate('/#contato')}
              >
                Solicitar proposta personalizada
              </button>
            </motion.div>
          </div>
        </div>

        <div className="service-content">
          <div className="container">
            {/* Seção: Áreas de atuação */}
            <motion.div 
              className="areas-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2>Áreas de atuação</h2>
              <div className="areas-grid">
                <div className="area-card">
                  <FaCode className="area-icon" />
                  <h3>Desenvolvimento de Software</h3>
                  <p>
                    Arquitetura de sistemas, boas práticas, tecnologias modernas e 
                    metodologias de desenvolvimento eficientes.
                  </p>
                </div>
                <div className="area-card">
                  <FaPalette className="area-icon" />
                  <h3>UX/UI</h3>
                  <p>
                    Design de experiências do usuário, interfaces intuitivas, 
                    pesquisa de usuários e prototipação.
                  </p>
                </div>
                <div className="area-card">
                  <FaRocket className="area-icon" />
                  <h3>Empreendedorismo Tech</h3>
                  <p>
                    Estratégias para startups, validação de ideias, 
                    captação de investimentos e crescimento de negócios tech.
                  </p>
                </div>
                <div className="area-card">
                  <FaCogs className="area-icon" />
                  <h3>Agile e Produto</h3>
                  <p>
                    Metodologias ágeis, gestão de produtos, 
                    Scrum, Kanban e otimização de processos.
                  </p>
                </div>
                <div className="area-card">
                  <FaLightbulb className="area-icon" />
                  <h3>Outras sob demanda</h3>
                  <p>
                    Temas personalizados conforme a necessidade específica 
                    da sua empresa ou evento.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Seção: Tipos de formato */}
            <motion.div 
              className="formats-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <h2>Tipos de formato</h2>
              <div className="formats-grid">
                <div className="format-card">
                  <FaComments className="format-icon" />
                  <h3>Consultorias 1:1 ou em grupo</h3>
                  <p>
                    Sessões personalizadas para resolver desafios específicos, 
                    seja individualmente ou com equipes.
                  </p>
                </div>
                <div className="format-card">
                  <FaVideo className="format-icon" />
                  <h3>Palestras presenciais ou online</h3>
                  <p>
                    Apresentações inspiradoras e educativas para eventos, 
                    conferências e encontros corporativos.
                  </p>
                </div>
                <div className="format-card">
                  <FaBook className="format-icon" />
                  <h3>Cursos sob medida</h3>
                  <p>
                    Programas de capacitação customizados para as necessidades 
                    específicas da sua organização.
                  </p>
                </div>
                <div className="format-card">
                  <FaTools className="format-icon" />
                  <h3>Workshops práticos</h3>
                  <p>
                    Sessões hands-on com exercícios práticos e aplicação 
                    imediata dos conceitos aprendidos.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Seção: Para quem é? */}
            <motion.div 
              className="audience-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h2>Para quem é?</h2>
              <div className="audience-grid">
                <div className="audience-item">
                  <FaBuilding className="audience-icon" />
                  <span>Empresas</span>
                </div>
                <div className="audience-item">
                  <FaRocket className="audience-icon" />
                  <span>Startups</span>
                </div>
                <div className="audience-item">
                  <FaUniversity className="audience-icon" />
                  <span>Faculdades</span>
                </div>
                <div className="audience-item">
                  <FaCalendarAlt className="audience-icon" />
                  <span>Eventos</span>
                </div>
                <div className="audience-item">
                  <FaHeart className="audience-icon" />
                  <span>ONGs</span>
                </div>
                <div className="audience-item">
                  <FaGlobe className="audience-icon" />
                  <span>E muito mais!</span>
                </div>
              </div>
            </motion.div>

            {/* Seção: Diferenciais */}
            <motion.div 
              className="differentials-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <h2>Nossos Diferenciais</h2>
              <div className="differentials-grid">
                <div className="differential-card">
                  <FaComments className="differential-icon" />
                  <h3>Linguagem acessível</h3>
                  <p>
                    Explicamos conceitos complexos de forma simples e 
                    compreensível para qualquer público.
                  </p>
                </div>
                <div className="differential-card">
                  <FaTools className="differential-icon" />
                  <h3>Abordagem prática</h3>
                  <p>
                    Focamos em aplicação real dos conhecimentos, 
                    não apenas teoria, mas resultados práticos.
                  </p>
                </div>
                <div className="differential-card">
                  <FaStar className="differential-icon" />
                  <h3>Conteúdo atualizado</h3>
                  <p>
                    Mantemos nossos materiais sempre atualizados com 
                    as últimas tendências e tecnologias do mercado.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Seção: Galeria de eventos anteriores */}
            {/* <motion.div 
              className="events-gallery-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <h2>Galeria de eventos anteriores</h2>
              <div className="events-grid">
                <div className="event-card">
                  <div className="event-image">
                    <img 
                      src="https://via.placeholder.com/400x250/00AFEF/FFFFFF?text=Palestra+Tech" 
                      alt="Palestra sobre tecnologia"
                    />
                  </div>
                  <div className="event-info">
                    <h3>Palestra: "O Futuro do Desenvolvimento Web"</h3>
                    <p className="event-location">Universidade XYZ - 2023</p>
                    <p className="event-description">
                      Palestra sobre as tendências e tecnologias emergentes 
                      no desenvolvimento web moderno.
                    </p>
                  </div>
                </div>
                
                <div className="event-card">
                  <div className="event-image">
                    <img 
                      src="https://via.placeholder.com/400x250/0081A5/FFFFFF?text=Workshop+UX" 
                      alt="Workshop de UX"
                    />
                  </div>
                  <div className="event-info">
                    <h3>Workshop: "UX Design na Prática"</h3>
                    <p className="event-location">Startup ABC - 2023</p>
                    <p className="event-description">
                      Workshop prático sobre design de experiências do usuário 
                      com exercícios hands-on.
                    </p>
                  </div>
                </div>
                
                <div className="event-card">
                  <div className="event-image">
                    <img 
                      src="https://via.placeholder.com/400x250/606062/FFFFFF?text=Consultoria" 
                      alt="Sessão de consultoria"
                    />
                  </div>
                  <div className="event-info">
                    <h3>Consultoria: "Transformação Digital"</h3>
                    <p className="event-location">Empresa DEF - 2023</p>
                    <p className="event-description">
                      Consultoria especializada para implementação de 
                      estratégias de transformação digital.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div> */}

            {/* Seção: CTA Final */}
            <motion.div 
              className="final-cta-section"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
            >
              <h2>Quer levar mais conhecimento para sua equipe ou evento?</h2>
              <p>
                Entre em contato e vamos criar uma proposta personalizada 
                que atenda exatamente às necessidades da sua organização.
              </p>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/#contato')}
              >
                Entre em contato
              </button>
            </motion.div>
          </div>
        </div>
        <WhatsappFloat />
      </div>
    </>
  );
};

export default Consultorias; 